import React from 'react';
import { Colors } from '../../../themes/colors';

import { ProperksChallengeForm } from './components/ProperksChallengeForm';
import { ProperksChallengeList } from './components/ProperksChallengeList';

export const ProPerks = () => (
  <div
    id="properks-page"
    style={{
      display: 'flex',
      height: '100vh',
      overflowY: 'auto',
      flexDirection: 'column',
      position: 'relative',
      alignItems: 'center',
      backgroundColor: Colors.background,
    }}
  >
    <h1
      className="global_font f-dark"
      style={{
        fontSize: 24,
        fontWeight: 'bold',
        marginTop: 45,
        marginBottom: 15,
        textAlign: 'center',
      }}
    >
      ProPerks
    </h1>
    <ProperksChallengeForm />
    <ProperksChallengeList />
  </div>
);

export default ProPerks;
